import React from "react";

 const ConfirmationPage=({ confirm, onCancel, onDelete ,topicName})=> {
  if (!confirm) return null;
  return (
    <>
      <div className="fixed z-50 inset-0 overflow-y-auto duration-300 ease-in-out font-sans">
        <div className="flex items-center justify-center min-h-screen p-4 text-center sm:p-6">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-foreground/60"></div>
          </div>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <div
            className="inline-block w-full bg-card rounded-xl border border-border space-y-4 px-4 sm:px-6 pt-5 pb-4 sm:p-6 text-left overflow-hidden shadow-theme transform transition-all sm:my-auto sm:align-middle sm:max-w-sm"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div className="h-1.5 card-gradient-strip -mx-4 sm:-mx-6 -mt-5 sm:-mt-6 rounded-t-xl" />
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg
                  className="h-6 w-6 text-red-600"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3
                  className="font-heading text-lg leading-6 font-bold text-primary"
                  id="modal-headline"
                >
                  Delete {topicName}
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-muted-foreground">
                    Are you sure you want to delete this {topicName}? This action
                    cannot be undone.
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col-reverse sm:flex-row items-stretch sm:items-center gap-3 sm:space-x-4">
              <button
                type="button"
                onClick={onCancel}
                className="bef-btn-secondary w-full"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={onDelete}
                className="w-full min-h-[2.75rem] rounded-xl border border-transparent shadow-theme px-4 py-2 bg-red-600 text-sm font-bold text-white hover:bg-red-700 focus:outline-none transition-all duration-300"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    
    </>
  );
}
export default ConfirmationPage
